<template>
    <v-navigation-drawer v-model="internalDrawer">
    <v-list>
        <v-list-item
        v-for="(item, i) in showitems"
        :key="i"
        :value="item.id"
        :to="item.link"
        color="primary">

        <template v-slot:prepend>
            <v-icon :icon="item.icon"></v-icon>
        </template>

        <v-list-item-title v-text="item.text"></v-list-item-title>
        
        </v-list-item>
    </v-list>
    </v-navigation-drawer>
</template>


<script>

export default {
  name: 'TopMenu',

  data: () => ({
      items: [
        { id: 0, text: 'エリア', icon: 'mdi-earth', link: '/area', loginshow: false},
        { id: 1, text: '競技', icon: 'mdi-run', link: '/sportsstore', loginshow: false},
        { id: 2, text: 'スポーツ店', icon: 'mdi-home', link: '/sportsstore', loginshow: false},
        { id: 3, text: 'スポーツ施設', icon: 'mdi-city-variant', link: '/sportsstore', loginshow: false},
        { id: 4, text: 'スクール', icon: 'mdi-human-male-board', link: '/sportschool', loginshow: false},
        { id: 5, text: 'チーム', icon: 'mdi-account-group', link: '/teamclubcircle' , loginshow: false},
        { id: 6, text: '飲食店', icon: 'mdi-silverware-fork-knife', link: '/food', loginshow: false},
        { id: 7, text: 'リンク', icon: 'mdi-link-box-variant', link: '/link', loginshow: false},
        { id: 8, text: 'マイページ', icon: 'mdi-account', link: '/mypage', loginshow: true},
      ],
      selectedItem: 1,
    }),
    props: {
      modelValue: {
        type: Boolean,
        default: false
      }
    },
    emits: ['update:modelValue'],
    computed: {
      internalDrawer: {
        get() {
          return this.modelValue;
        },
        set(val) {
          this.$emit('update:modelValue', val);
        }
      },
      showitems() {
        if (this.$store.getters.getToken) {
          // ログイン中
          return this.items
        } else {
          // ログインしてない
          return this.items.filter(item => item.loginshow === false)
        }
      }
    },
}
</script>